// For anything popup modals related
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-action="cr-display-form"]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // Display Contractor Reporting interest form
      document.getElementById('cr-interest-form').style.display = 'flex';
    });
  });

  document.querySelectorAll('[data-action="cr-hide-form"]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // Hide Contractor Reporting interest form
      document.getElementById('cr-interest-form').style.display = 'none';
    });
  });

  // Display Create Contractor popup modal
  document.addEventListener('click', (event) => {
    if (event.target.matches('[data-action="create-contractor-display-modal"]')) {
      event.preventDefault();
      document.getElementById('create-contractor-modal').style.display = 'flex';
      document.getElementById('results').innerHTML = '';
      document.getElementsByClassName('js-contractor-modal-contractor-name')[0].value = document.getElementsByClassName('js-contractor-modal-name-target')[0].value;
    }
  });

  document.querySelectorAll('[data-action="create-contractor-hide-modal"]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // Hide Create Contractor popup modal
      document.getElementById('create-contractor-modal').style.display = 'none';
      document.getElementById('contractor_name').value = '';
    });
  });
});
